module.exports = __webpack_public_path__ + "img/venus-double.13b162cb.svg";